import { render } from "./ComplaintHandleLog.vue?vue&type=template&id=fb931752&scoped=true"
import script from "./ComplaintHandleLog.vue?vue&type=script&lang=js"
export * from "./ComplaintHandleLog.vue?vue&type=script&lang=js"

import "./ComplaintHandleLog.vue?vue&type=style&index=0&id=fb931752&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb931752"]])

export default __exports__